import React from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { InquiryForm } from "@/components/site/InquiryForm";
import { EnvelopeSimple, MapPin, Phone } from "@phosphor-icons/react";

export default function ContactPage() {
  return (
    <div className="App">
      <Navbar />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 lg:grid-cols-12 gap-12" data-testid="contact-page">
        <div className="lg:col-span-5">
          <div className="label-uppercase">Contact</div>
          <h1 className="h1 text-5xl md:text-6xl mt-4">Let's talk.</h1>
          <p className="mt-6 text-lg text-[var(--text-secondary)] max-w-md">
            Drop us a message. We typically reply within 24 hours with availability and viewing slots.
          </p>

          <div className="mt-10 space-y-6">
            <Item icon={<EnvelopeSimple size={20} />} label="Email" value="ampmpropertyinvestments@gmail.com" href="mailto:ampmpropertyinvestments@gmail.com" />
            <Item icon={<Phone size={20} />} label="Phone" value="07365 813254" href="tel:+447365813254" />
            <Item icon={<MapPin size={20} />} label="Area" value="Hull, East Yorkshire, UK" />
          </div>
        </div>

        <div className="lg:col-span-7 bg-white border border-[var(--border-subtle)] p-8">
          <InquiryForm />
        </div>
      </section>

      <Footer />
    </div>
  );
}

const Item = ({ icon, label, value, href }) => (
  <div className="flex items-start gap-4 border-t border-[var(--border-subtle)] pt-6">
    <div className="text-[var(--text-primary)]">{icon}</div>
    <div>
      <div className="label-uppercase">{label}</div>
      {href ? (
        <a href={href} className="mt-1 inline-block link-inline" data-testid={`contact-${label.toLowerCase()}-link`}>{value}</a>
      ) : (
        <div className="mt-1">{value}</div>
      )}
    </div>
  </div>
);
